import React from 'react';

import { Box } from '@chakra-ui/react';
import { useOKRAccessControl } from 'components/RabbitOKRSidePanel/AccessControl/useOKRAccessControl';
import { openCreateOKRPanel } from 'components/RabbitOKRSidePanel/krDrawerSecondaryPanelSlice';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch, useSelector } from 'react-redux';
import { kRDrawerSelector } from 'selectors/kRDrawer';

import NoDataImg from 'assets/assetsV1/illustrations/noGoals.svg';

import { OKR_TYPES } from 'constants/ProjectConstants';
import { StringModifier, modifyString } from 'constants/copyHelpers';

import { Button } from 'uiToolkitV1/Button';
import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { SplitButton } from 'uiToolkitV1/SplitButton';
import { TextHeader3 } from 'uiToolkitV1/Typography';

const NoSupportedByCta = () => {
  const dispatch = useDispatch();
  const { uuid, type, text, visibilityType, timeBoundDetails, progressType, measure, measureType } =
    useSelector(kRDrawerSelector);
  const { objectivesName, keyResultsName } = useOrganisationSettings();

  const { canCreateKeyResult, canCreateObjective } = useOKRAccessControl();

  const handleAddChild = (okrPanelType) => {
    const payload = {
      type: okrPanelType,
      parentPost: {
        uuid,
        type,
        text,
        visibilityType,
      },
      timeBoundDetails,
      parentProgressType: progressType,
      parentMeasure: measure,
      parentMeasureType: measureType,
    };
    dispatch(openCreateOKRPanel(payload));
  };

  const objectionOption = {
    value: OKR_TYPES.OBJECTIVE,
    label: `Add Child ${objectivesName}`,
    onClick: () => handleAddChild(OKR_TYPES.OBJECTIVE),
  };

  const keyResultOption = {
    value: OKR_TYPES.KEY_RESULT,
    label: `Add Child ${keyResultsName}`,
    onClick: () => handleAddChild(OKR_TYPES.KEY_RESULT),
  };

  const options = [];

  if (canCreateKeyResult) options.push(keyResultOption);
  if (canCreateObjective) options.push(objectionOption);
  return (
    <>
      {options.length === 1 ? (
        <Button variant="outlined" onClick={options[0]?.onClick} style={{ height: '32px' }}>
          {options[0]?.label}
        </Button>
      ) : null}
      {options.length > 1 ? (
        <SplitButton
          buttonProps={{
            style: { padding: '8px', borderRadius: '4px 0px 0px 4px' },
          }}
          menuButtonProps={{
            style: { padding: '8px', borderRadius: '0px 4px 4px 0px' },
          }}
          options={options}
        />
      ) : null}
    </>
  );
};

export const NoSupportedBy = ({ isOKRPanelDisabled }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  const renderHeaderComponent = () => (
    <TextHeader3 as="h2" bold mt="24px">
      There is no child {modifyString(objectivesName, StringModifier.SENTENCE_CASE)} or{' '}
      {modifyString(keyResultsName, StringModifier.SENTENCE_CASE)}
    </TextHeader3>
  );

  return (
    // adding padding to the bottom to avoid the CTA options to be hidden behind the bottom bar
    <Box paddingBottom="50px">
      <EmptyScreen
        headerComp={renderHeaderComponent}
        description={`Create a child ${modifyString(objectivesName, StringModifier.SENTENCE_CASE)} or ${modifyString(
          keyResultsName,
          StringModifier.SENTENCE_CASE
        )}.`}
        illustrationSrc={NoDataImg}
        illustrationStyle={{ marginTop: '64px' }}
        CTAComp={isOKRPanelDisabled ? null : NoSupportedByCta}
        CTAContainerStyle={{ paddingBottom: '24px' }}
      />
    </Box>
  );
};
